import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { SettingsPage } from '../../pages/settings/settings';
import { SpinnerDialog } from '@ionic-native/spinner-dialog';
import { Shared } from '../../providers/shared';

@Component({
    selector: 'settings-icon',
    templateUrl: 'settings-icon.html'
})
export class SettingsIconComponent {

    constructor(
        private navCtrl: NavController,
        private shared: Shared,
        private spinner: SpinnerDialog,
    ) {
    }

    async loadSettings() {
        this.spinner.show();

        let user = await this.shared.get('user');
        this.navCtrl.push(SettingsPage, {user: user});
        this.spinner.hide();
    }
}



// WEBPACK FOOTER //
// ./src/components/settings-icon/settings-icon.ts